import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Legals from "./screens/Legals";
import Rejection from "./screens/Rejection";
import ErrorBoundary from "./screens/ErrorBoundary";
import Wait from "./screens/Wait";
import NewApply from "./screens/NewApply";
import Confirm from "./screens/Confirm";
import Wait_UBOs from "./screens/Wait_UBOs";
import Accounts from "./screens/Accounts";
import WaitBusinessCheck from "./screens/WaitBusinessCheck";
import EndeavourMobile from "./screens/EndeavourMobile";
import KYC from "./screens/KYC";
import KYC_UBO from "./screens/KYC_UBO";
import { Button } from "react-bootstrap";
import signOut from "./lib/signOut";
import Closed from "./screens/Closed";
import CreationPending from "./screens/CreationPending";
import AccountBlocked from "./screens/AccountBlocked";

export default function App() {

  function DoSignOut() {
    return (
      <Button
        onClick={() => signOut()}
        className="or-logout"
        // style={{
        //   top: 0,
        //   right: "2%",
        //   borderTopLeftRadius: 0,
        //   borderTopRightRadius: 0,
        //   background: "black",
        //   border: "black",
        //   position: "fixed",
        //   zIndex: 100,
        // }}
      >
        Log Out
      </Button>
    );
  }

  return (
    <ErrorBoundary>
      <Router>
        <Switch>
          <Route path="/onboarding/new_apply" component={NewApply} />
          <Route path="/onboarding/wait" component={Wait} />
          <Route path="/onboarding/confirm" component={Confirm} />
          <Route path="/onboarding/legals" component={Legals} />
          <Route path="/onboarding/rejection" component={Rejection} />
          <Route path="/onboarding/accounts" component={Accounts} />
          <Route path="/onboarding/wait_ubos" component={Wait_UBOs} />
          <Route
            path="/onboarding/wait_business_check"
            component={WaitBusinessCheck}
          />
          <Route path="/attributes/yoti" component={EndeavourMobile} />
          <Route path="/onboarding/kyc" component={KYC} />
          <Route path="/onboarding/kyc_ubo" component={KYC_UBO} />
          <Route path="/onboarding/creation_pending" component={CreationPending} />
          <Route path="/onboarding/closed" component={Closed} />
          <Route path="/onboarding/blocked" component={AccountBlocked} />
        </Switch>
        {(window.location.href.match( "(onboarding|attributes\/yoti)" )) ? <DoSignOut /> : null}
      </Router>
    </ErrorBoundary>
  );
}
